module.exports = "/_next/static/media/onboard-3-import.3bb47248.webm";